import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { buttonVariants, LinkButton } from '@/ui/atoms/button/Button'
import { Typography } from '@/ui/atoms/typography/Typography'

interface EmptyCardProps {
  header: string
  buttonText?: string
  href?: string
  setMobileMenuCollapsed?: (collapsed: boolean) => void
}

export function EmptyCard({ header, buttonText, href, setMobileMenuCollapsed }: EmptyCardProps) {
  const { close } = useSideDrawer()

  return (
    <div className="mt-4 flex flex-col items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/4 px-4 py-6">
      <Typography variant="p">{header}</Typography>
      {href && buttonText && (
        <LinkButton
          href={href}
          className={buttonVariants({ size: 'sm' })}
          onClick={() => {
            setMobileMenuCollapsed?.(true)
            close()
          }}
        >
          {buttonText}
        </LinkButton>
      )}
    </div>
  )
}
